import { render, staticRenderFns } from "./chooseShopGoodsType.vue?vue&type=template&id=279fc06d&scoped=true&"
import script from "./chooseShopGoodsType.vue?vue&type=script&lang=js&"
export * from "./chooseShopGoodsType.vue?vue&type=script&lang=js&"
import style0 from "./chooseShopGoodsType.vue?vue&type=style&index=0&id=279fc06d&lang=less&scoped=true&"
import style1 from "./chooseShopGoodsType.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279fc06d",
  null
  
)

component.options.__file = "chooseShopGoodsType.vue"
export default component.exports